angular.module("financialDataQuotation.components", [])
    .component("financialDataQuotation", {
        templateUrl: "ng/components/financialDataQuotation/financialDataQuotation.view.html",
        bindings: {
            model: "=",
            vendor: "=",
            customer: "=",
            deroghe: "<",
            leasingData: "=",
            verifica: '=',
            readOnly: '<',
            isRiepilogoControllo: '<',
            workflowInfo: '=',
            warningQuestAgv: "<"
        },
        controllerAs: "financialDataQuotationCtrl",
        controller: FinancialQuotation
    })

function FinancialQuotation(
    $timeout,
    $configService
) {
    var self = this;

    self.$onInit = function () {
        self.numberOfCharMax = 20;
        self.showRadio = false;
        checkAndEnableTooltip();
        if (self.vendor.reteVendita != 5) {
            self.showRadio = true;
        }
        if (self.isRiepilogoControllo) {

            self.assNoDistanza = self.leasingData.preventivo.assicurazioni.some(function (element) {
                return element.tipoAssicurazione != 'D' && !element.aDistanza
            })
			
			self.assParteSoloPassiva = self.leasingData.preventivo.assicurazioni.some(function (element) {
			    return element.tipoAssicurazione != 'D' && element.parteSoloPassiva
			})
			
        }
        self.mandatoryData();
        self.showAlert = false;
    }

    self.$onChanges = function () {
        self.deroghe && self.deroghe.forEach(function (deroga) {
            if (deroga.codiceTipoDeroga === 'FIN') {
                self.codiceTipoDerogaValoreMinimoFin = deroga.referenceValue.minimo.valore;
                self.codiceTipoDerogaValoreMassimoFin = deroga.referenceValue.massimo.valore;
                self.userCanApproveFin = deroga.userCanApprove;
                self.upFin = deroga.up;
                self.derogaFinPresent = true;
            }

            if (deroga.codiceTipoDeroga === 'ANT') {
                self.codiceTipoDerogaValoreMinimoAnt = deroga.referenceValue.minimo.valore;
                self.codiceTipoDerogaValoreMassimoAnt = deroga.referenceValue.massimo.valore;
                self.userCanApproveAnt = deroga.userCanApprove;
                self.upAnt = deroga.up;
                self.derogaAntPresent = true;
            }

            if (deroga.codiceTipoDeroga === 'RST') {
                self.codiceTipoDerogaValoreMinimoRst = deroga.referenceValue.minimo.valore;
                self.codiceTipoDerogaValoreMassimoRst = deroga.referenceValue.massimo.valore;
                self.userCanApproveRst = deroga.userCanApprove;
                self.upRst = deroga.up;
                self.derogaRstPresent = true;
            }

            if (deroga.codiceTipoDeroga === 'PVF') {
                self.derogaPvfPresent = true;
                self.userCanApprovePvf = deroga.userCanApprove;
                self.upPvf = deroga.up;
            }

            if (deroga.codiceTipoDeroga === 'MCZ') {
                self.referenceValueTextMcz = deroga.referenceValueText
                self.derogaMczPresent = true;
                self.userCanApproveMcz = deroga.userCanApprove;
            }

            if (deroga.codiceTipoDeroga === 'DUR') {
                self.codiceTipoDerogaValoreMinimoDur = deroga.referenceValueInt.minimo.valore;
                self.codiceTipoDerogaValoreMassimoDur = deroga.referenceValueInt.massimo.valore;
                self.userCanApproveDur = deroga.userCanApprove;
                self.upDur = deroga.up;
                self.derogaDurPresent = true;
            }

            if (deroga.codiceTipoDeroga === 'TIF' || deroga.codiceTipoDeroga === "TII") {
                self.codiceTipoDerogaValoreMinimoTifTii = deroga.referenceValue.minimo.valore;
                self.codiceTipoDerogaValoreMassimoTifTii = deroga.referenceValue.massimo.valore;
                self.codiceTipoDerogaValoreMinimoTifTiiReale = self.model.preventivo.validations.spreadNettoReale.minimo.valore;
                self.userCanApproveTifTii = deroga.userCanApprove;
                self.upTifTii = deroga.up;
                self.derogaTifTiiPresent = true;
            }

            if (deroga.codiceTipoDeroga === 'TBA') {
                self.codiceTipoDerogaValoreMinimoTba = deroga.referenceValue.minimo.valore;
                self.codiceTipoDerogaValoreMassimoTba = deroga.referenceValue.massimo.valore;
                self.userCanApproveTba = deroga.userCanApprove;
                self.upTba = deroga.up;
                self.derogaTbaPresent = true;
            }
        })
    }

    var checkAndEnableTooltip = function () {
        $timeout(function () {
            if (self.customer.metadata.riUserG.ragioneSociale.length > self.numberOfCharMax) {
                self.enableToltipClient = true;
            }
        }, 500);
    }

    self.check = function (el) {
        self.mandatoryData();
        if (!self.showAlert) {
            el.selected = !el.selected;
            if (el.selected) {
                el.ndg = $configService.getUser().ndg;
                el.identifier = $configService.getUser().identifier;
                el.dataConferma = moment().format("DD/MM/YYYY");
            } else {
                el.ndg = "";
                el.identifier = "";
                el.dataConferma = "";
            }
        }
    }

    self.mandatoryData = function () {
        if (self.showRadio && self.isRiepilogoControllo && self.model.preventivo.nuovoPrestoleasingConDeroga && self.workflowInfo.skipHfAndWait) {
            self.radioSelected = true;
        } else if (self.workflowInfo && self.isRiepilogoControllo && self.showRadio && self.workflowInfo.skipHfAndWait != undefined) {
            self.radioSelected = true;
        } else {
            self.radioSelected = false;
        }

        if (self.workflowInfo && self.isRiepilogoControllo && self.showRadio && !self.radioSelected) {
            self.showAlert = true;
            self.verifica.selected = false;
        } else {
            self.showAlert = false;
        }
    }
}